"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPiggyBank = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconPiggyBank = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "44",
    height: "40",
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M30.9428 40H25.3546L25.0216 37.7743C24.2044 37.8898 23.3804 37.9628 22.558 37.9883V38.0002L21.8308 38.0019C21.6711 38.0019 21.5114 38.0002 21.3517 37.9968C21.2973 37.9968 21.2378 37.9934 21.1784 37.9917L21.0781 37.9883C20.9558 37.9832 20.8504 37.9798 20.7451 37.9747C20.5072 37.9629 20.2694 37.9493 20.0332 37.9306L19.9381 37.9238C19.3536 37.8779 18.7861 37.8116 18.2425 37.7301L16.6539 40H11.0452V35.3787C6.00588 32.7656 2.11177 28.4482 0.0509718 23.1779L0 23.0487V17.5101H0.727193C3.04465 17.5101 5.18021 16.596 6.58728 15.0006C7.65934 13.7858 8.72123 12.8106 9.82561 12.0291V6.53607H10.5528C12.8686 6.53607 15.0398 7.40597 16.7082 8.99454C18.3682 8.60376 20.0893 8.40666 21.8306 8.40666C31.9297 8.40666 40.1442 15.0449 40.1442 23.2037C40.1442 27.6228 37.7418 31.76 33.5469 34.582L30.9428 40ZM26.6103 38.5456H30.0288L32.4125 33.5893L32.5807 33.4789C36.4647 30.9287 38.6922 27.1839 38.6922 23.2049C38.6922 15.8482 31.1297 9.86241 21.8327 9.86241C20.0691 9.86241 18.331 10.0782 16.6659 10.503L16.2547 10.6083L15.9608 10.3025C14.7019 8.98915 13.0606 8.19567 11.2816 8.02577V12.8002L10.9588 13.016C9.84425 13.7619 8.77218 14.7252 7.67967 15.9638C6.14717 17.7002 3.90783 18.7621 1.45467 18.9388V22.7735C3.45274 27.7889 7.22645 31.8717 12.094 34.2792L12.4984 34.4797V38.5455H15.8947L17.5767 36.1414L18.0321 36.2195C18.6675 36.33 19.3471 36.4149 20.0522 36.4693L20.1491 36.4761C20.3699 36.4931 20.5925 36.5067 20.8151 36.5168C20.9153 36.5219 21.0155 36.5253 21.1141 36.5287L21.2432 36.5338C21.2891 36.5355 21.3333 36.5372 21.3791 36.5389C21.4709 36.5406 21.5626 36.5423 21.6527 36.544H21.8311C23.0561 36.544 24.293 36.437 25.5078 36.2229L26.2434 36.0938L26.6103 38.5456Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M39.4191 23.9308V22.4764C40.865 22.4764 42.0407 21.3006 42.0407 19.8565H43.4951C43.4951 22.1026 41.667 23.9308 39.4191 23.9308Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M11.03 20.6464C9.70132 20.6464 8.62073 19.5659 8.62073 18.2372H10.0751C10.0751 18.7639 10.5033 19.1921 11.03 19.1921C11.5567 19.1921 11.9848 18.7639 11.9848 18.2372H13.4392C13.4392 19.5659 12.3586 20.6464 11.03 20.6464Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M22.4614 27.6008H21.2381C20.5551 27.6008 19.9128 27.3341 19.4269 26.8533C18.9426 26.3673 18.6759 25.7234 18.6759 25.037H20.1303C20.1303 25.3343 20.2458 25.613 20.4531 25.8236C20.6621 26.0309 20.9407 26.1465 21.2364 26.1465H22.4597C22.7536 26.1465 23.0322 26.0309 23.2429 25.8219C23.4485 25.6164 23.564 25.336 23.564 25.0387C23.564 24.7431 23.4502 24.4661 23.2429 24.2605C23.0322 24.0498 22.7536 23.9343 22.4597 23.9343H21.2364C20.5517 23.9343 19.9077 23.6676 19.4235 23.1816C18.9409 22.7042 18.6742 22.0603 18.6742 21.3721C18.6742 20.6874 18.9409 20.0435 19.4235 19.5593C19.9077 19.075 20.5517 18.8083 21.2364 18.8083H22.4597C23.1427 18.8083 23.7866 19.075 24.2708 19.5576C24.7551 20.0418 25.0201 20.6858 25.0201 21.3721H23.5657C23.5657 21.0748 23.4502 20.7962 23.2429 20.5872C23.0339 20.3799 22.757 20.2644 22.4614 20.2644H21.2381C20.9424 20.2644 20.6638 20.3799 20.4548 20.5889C20.2475 20.7962 20.132 21.0765 20.132 21.3721C20.132 21.6695 20.2458 21.9447 20.4531 22.1503C20.6655 22.3627 20.9424 22.4782 21.2381 22.4782H22.4613C23.1444 22.4782 23.7883 22.745 24.2725 23.2292C24.7551 23.7084 25.0218 24.3523 25.0218 25.0387C25.0218 25.7251 24.7551 26.369 24.2742 26.8533C23.7849 27.3358 23.1427 27.6009 22.4613 27.6009L22.4614 27.6008Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M21.1208 17.6544H22.5752V19.5352H21.1208V17.6544Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M21.1208 26.8736H22.5752V28.7527H21.1208V26.8736Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M21.8476 6.95072C19.9311 6.95072 18.373 5.39103 18.373 3.47451C18.373 1.55799 19.9327 0 21.8476 0C23.7658 0 25.3255 1.55969 25.3255 3.47451C25.3255 5.39099 23.7658 6.95072 21.8476 6.95072ZM21.8476 1.45252C20.733 1.45252 19.8274 2.35808 19.8274 3.47264C19.8274 4.5872 20.733 5.49447 21.8476 5.49447C22.9621 5.49447 23.8694 4.5872 23.8694 3.47264C23.8711 2.35978 22.9621 1.45252 21.8476 1.45252Z",
      fill: color
    }, void 0)]
  }), void 0);
});